__turbopack_context__.v({
  "slider": "slider-module-scss-module__DcA-ha__slider",
  "slider-container": "slider-module-scss-module__DcA-ha__slider-container",
  "slider__output": "slider-module-scss-module__DcA-ha__slider__output",
  "slider__output--light": "slider-module-scss-module__DcA-ha__slider__output--light",
  "slider__thumb": "slider-module-scss-module__DcA-ha__slider__thumb",
  "slider__thumb--is-dragging": "slider-module-scss-module__DcA-ha__slider__thumb--is-dragging",
  "slider__thumb--is-focused": "slider-module-scss-module__DcA-ha__slider__thumb--is-focused",
  "slider__track-style": "slider-module-scss-module__DcA-ha__slider__track-style",
  "slider__track-style--1": "slider-module-scss-module__DcA-ha__slider__track-style--1",
  "slider__track-style--10": "slider-module-scss-module__DcA-ha__slider__track-style--10",
  "slider__track-style--2": "slider-module-scss-module__DcA-ha__slider__track-style--2",
  "slider__track-style--3": "slider-module-scss-module__DcA-ha__slider__track-style--3",
  "slider__track-style--4": "slider-module-scss-module__DcA-ha__slider__track-style--4",
  "slider__track-style--5": "slider-module-scss-module__DcA-ha__slider__track-style--5",
  "slider__track-style--6": "slider-module-scss-module__DcA-ha__slider__track-style--6",
  "slider__track-style--7": "slider-module-scss-module__DcA-ha__slider__track-style--7",
  "slider__track-style--8": "slider-module-scss-module__DcA-ha__slider__track-style--8",
  "slider__track-style--9": "slider-module-scss-module__DcA-ha__slider__track-style--9",
});
